import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const getReservationCart = (reservationCartId) =>
  axios.get(
    `${getV1RootUrl()}/reservation-cart/${reservationCartId}`,
    publicAxiosHeader()
  );

export const createReservationCart = (reservationCart) =>
  axios.post(
    `${getV1RootUrl()}/reservation-cart`,
    reservationCart,
    publicAxiosHeader()
  );

export const updateReservationCart = (reservationCartId, reservationCart) =>
  axios.put(
    `${getV1RootUrl()}/reservation-cart/${reservationCartId}`,
    reservationCart,
    publicAxiosHeader()
  );

export const processReservationCart = (reservationCartId) =>
  axios.put(
    `${getV1RootUrl()}/reservation-cart/${reservationCartId}/process`,
    null,
    publicAxiosHeader()
  );
